import DevAuth from "@/services/auth/Dev";
import ProdAuth from "@/services/auth/Prod";
import UserAuth from "@/entities/UserAuth";

const localCognitoEndpoint = process.env.VUE_APP_LOCAL_COGNITO_ENDPOINT;

const auth: UserAuth = localCognitoEndpoint
  ? new DevAuth(localCognitoEndpoint)
  : new ProdAuth();

export default auth;
